import { ActivityIndicator, StyleSheet, View } from "react-native";
import Svg, { Path } from "react-native-svg";
import { fp, hp, spH, spV } from "utils/normalizeV2";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";

import ComingSoonCop from "components/ComingSoonCop";
import ParentScrollView from "components/ParentScrollView";
import ShoppablePageItem from "components/Shoppable/ShoppablePageItem";
import ShoppableVideo from "components/Shoppable/ShoppableVideo";
import { TouchableOpacity } from "react-native";
import VText from "components/VText";
import Heading from "components/Heading";
import { getVideos } from "appRedux/reducers/homeSlice";

const LIMIT = 27;

const Videos = () => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);

    const userId = useSelector((state) => state.AuthReducer.userId);

    const dispatch = useDispatch();
    const _shoppableRef = useRef();
    const _scrollRef = useRef();

    const local = useLocalSearchParams();

    useEffect(() => {
        setLoading(true);
        dispatch(
            getVideos({
                page: page,
                size: LIMIT,
                gender: local?.gender ?? "female",
                userId: userId,
            })
        )
            .then((res) => {
                setLoading(false);
                if ([200].includes(res?.payload?.status) && Array.isArray(res?.payload?.data?.data)) {
                    setVideos(res?.payload?.data?.data);
                    setTotalPageCount(res?.payload?.data?.totalPages);
                    set;
                } else {
                    setVideos([]);
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log("err", err);
            });
    }, [page]);

    useEffect(() => {
        if (local?.page) {
            try {
                setPage(Number(local?.page));
            } catch (err) {}
        }
    }, [local?.page]);

    if (["male"].includes(local?.gender)) {
        return (
            <ParentScrollView _scrollRef={_scrollRef}>
                <ComingSoonCop type="VIDEOS"></ComingSoonCop>
            </ParentScrollView>
        );
    }

    return (
        <ParentScrollView _scrollRef={_scrollRef}>
            <View style={styles.container}>
                <Heading type="h1" style={styles.mainTitle}>Shoppable Videos</Heading>

                {loading && (
                    <ActivityIndicator
                        style={{
                            marginTop: 100,
                        }}
                        size={"large"}
                    />
                )}
                {!loading && <ShoppablePageItem _shoppableRef={_shoppableRef} item={videos} />}
            </View>
            <View
                style={{
                    paddingVertical: spV(48),
                    paddingHorizontal: spH(92),
                }}
            >
                <TouchableOpacity
                    style={{
                        marginBottom: spV(28),
                        alignSelf: "flex-end",
                    }}
                    activeOpacity={0.8}
                    onPress={() =>
                        _scrollRef?.current?.scrollTo({
                            x: 0,
                            y: 0,
                            animated: true,
                        })
                    }
                >
                    <Svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <Path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M30.001 5C16.1935 5 5.00098 16.1925 5.00098 30C5.00098 43.8075 16.1935 55 30.001 55C43.8085 55 55.001 43.8075 55.001 30C55.001 16.1925 43.8085 5 30.001 5ZM30.001 17.5C30.664 17.5001 31.2997 17.7636 31.7685 18.2325L41.7685 28.2325C42.2239 28.704 42.4759 29.3355 42.4702 29.991C42.4645 30.6465 42.2015 31.2735 41.738 31.737C41.2745 32.2006 40.6475 32.4635 39.992 32.4692C39.3365 32.4749 38.705 32.2229 38.2335 31.7675L32.501 26.035V40C32.501 40.663 32.2376 41.2989 31.7687 41.7678C31.2999 42.2366 30.664 42.5 30.001 42.5C29.3379 42.5 28.7021 42.2366 28.2332 41.7678C27.7644 41.2989 27.501 40.663 27.501 40V26.035L21.7685 31.7675C21.297 32.2229 20.6655 32.4749 20.01 32.4692C19.3545 32.4635 18.7275 32.2006 18.2639 31.737C17.8004 31.2735 17.5375 30.6465 17.5318 29.991C17.5261 29.3355 17.7781 28.704 18.2335 28.2325L28.2335 18.2325C28.7022 17.7636 29.338 17.5001 30.001 17.5Z"
                            fill="#212427"
                            fillOpacity="0.3"
                        />
                    </Svg>
                </TouchableOpacity>
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingTop: spV(28),
                        borderTopWidth: 1,
                        borderColor: "rgba(33, 36, 39, 0.3)",
                    }}
                >
                    <TouchableOpacity
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            cursor: page == 1 ? "not-allowed" : "pointer",
                        }}
                        activeOpacity={0.8}
                        onPress={() => {
                            setPage((prev) => {
                                if (prev == 1) {
                                    return 1;
                                } else {
                                    _scrollRef?.current?.scrollTo({
                                        x: 0,
                                        y: 0,
                                        animated: true,
                                    });
                                    router.setParams({ page: prev - 1 });
                                    return Number(prev) - 1;
                                }
                            });
                        }}
                    >
                        <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.0255 14L11 13.0255L5.97452 8L11 2.97452L10.0255 2L4.02548 8L10.0255 14Z"
                                fill="#212427"
                                fillOpacity={page == 1 ? "0.3" : "1"}
                            />
                        </Svg>

                        <VText
                            style={{
                                fontSize: fp(16),
                                color: page == 1 ? "rgba(33, 36, 39, 0.3)" : "#212427",
                                paddingLeft: 8,
                            }}
                            text={"Previous"}
                        />
                    </TouchableOpacity>
                    <VText
                        style={{
                            fontSize: fp(16),
                            color: "#212427",
                        }}
                        text={`Page ${page} of ${totalPageCount}`}
                    />
                    <TouchableOpacity
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            cursor: page == totalPageCount ? "not-allowed" : "pointer",
                        }}
                        activeOpacity={0.8}
                        onPress={() => {
                            setPage((prev) => {
                                if (prev == totalPageCount) {
                                    return totalPageCount;
                                } else {
                                    _scrollRef?.current?.scrollTo({
                                        x: 0,
                                        y: 0,
                                        animated: true,
                                    });
                                    router.setParams({ page: Number(prev) + 1 });
                                    return Number(prev) + 1;
                                }
                            });
                        }}
                    >
                        <VText
                            style={{
                                fontSize: fp(16),
                                color: page == totalPageCount ? "rgba(33, 36, 39, 0.3)" : "#212427",
                                paddingRight: 8,
                            }}
                            text={"Next"}
                        />
                        <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <Path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5.97452 14L5 13.0255L10.0255 8L5 2.97452L5.97452 2L11.9745 8L5.97452 14Z"
                                fill={page == totalPageCount ? "rgba(33, 36, 39, 0.3)" : "#212427"}
                            />
                        </Svg>
                    </TouchableOpacity>
                </View>
            </View>
            <ShoppableVideo source="Shoppable Videos" gender={local?.gender ?? "female"} ref={_shoppableRef} />
        </ParentScrollView>
    );
};

export default Videos;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        minHeight: hp(500),
    },
    mainTitle: {
        alignSelf: "center",
        marginTop: spV(28),
        fontFamily: "LibreBodoni",
        fontSize: fp(28),
        fontWeight: "300",
    },
});
